<template>
    <div class="el-Require">
        <el-row class="page_content">
            <h1 class="head_title">{{ $getShowName() }}查重</h1>
            <!-- 论文查重页 -->
            <div class="checkcontent" v-show="flag1">
                <div class="topbanner1">
                    <img src="../../images/vpcs.png" alt="">
                </div>
                <el-row>
                    <el-col :span="24">
                        <el-form :model="ruleForm" status-icon ref="ruleForm" :rules="rules" label-width="100px"
                            class="demo-ruleForm">
                            <el-form-item label="论文题目:" prop="title">
                                <el-input type="text" v-model="ruleForm.title" autocomplete="off"
                                    :disabled="isDisabled"></el-input>
                            </el-form-item>
                            <el-form-item label="论文作者:" prop="author">
                                <el-input type="text" v-model="ruleForm.author" autocomplete="off"
                                    :disabled="isDisabled"></el-input>
                            </el-form-item>
                            <el-form-item label="论文上传：" prop="fileName">
                                <input type="file" @change="onFileChange" :disabled="isDisabled" />
                            </el-form-item>
                            <el-form-item label="">
                                <div class="notice">
                                    <p>注意事项：</p>
                                    <p>1、文档大小请不要超过 10M，否则将无法上传。可将论文中的图片删除（系统不检测图片）</p>
                                    <p>2、支持文档格式：WORD文件（.doc .docx）、文本文件（.txt）</p>
                                </div>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="saveUpdate" :loading="uploadLoading"
                                    :disabled="isDisabled">提交</el-button>
                                <el-button @click="resetForm('ruleForm')" :disabled="isDisabled">重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <el-row style="padding-bottom: 10px;">
                    <p>
                        检测报告
                    </p>
                    <el-table :data="thesisPlagiarismCheckListData" border width="100%">
                        <el-table-column type="index" label="序号" width="100">
                        </el-table-column>
                        <el-table-column prop="paramTitle" label="论文标题" align="center">
                        </el-table-column>
                        <el-table-column prop="paramAuthor" label="作者" align="center">
                        </el-table-column>
                        <el-table-column prop="submitTime" label="提交时间" align="center">

                        </el-table-column>
                        <el-table-column prop="name" label="状态结果" align="center">
                            <template slot-scope="scope">
                                <span v-if="scope.row.checkStatus == null">创建成功</span>
                                <span v-if="scope.row.checkStatus == 0">创建成功</span>
                                <span v-if="scope.row.checkStatus == 1">正在检测</span>
                                <span v-if="scope.row.checkStatus == 2" style="color:green">检测完成</span>
                                <span v-if="scope.row.checkStatus == 3">检测完成</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="repetitiveRate" label="论文重复率" align="center">
                        </el-table-column>
                        <el-table-column prop="name" align="center" label="报告下载
"> <template slot-scope="scope">
                                <a class="linka" @click=" downloadFile(scope.row.reportUrl)">下载</a>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
            </div>
            <div class="order" v-show="flag2">
                <p class="blodfont">
                    核对订单信息
                </p>
                <el-table :data="orderData" border width="100%">
                    <el-table-column prop="outTradeNo" label="订单号">
                    </el-table-column>
                    <el-table-column prop="title" label="文章题目">
                    </el-table-column>
                    <el-table-column prop="author" label="文章作者">
                    </el-table-column>
                </el-table>
                <el-row class="orderpaysyle">
                    <el-col :span="12">
                        <p class="blodfont">
                            支付方式
                        </p>
                    </el-col>
                    <el-col :span="12">
                        <p class="blodfont">
                            核对金额
                        </p>
                    </el-col>
                </el-row>
                <el-row class="moneypart">
                    <div class="choose-way">
                        <ul>
                            <li v-for="(item, index) in changepay" @click="tab(item.value)"
                                :class="{ active: item.value == activeval }">
                                <div class="icheckbox_sr hidden">
                                </div>
                                <i class="icon-pw"><img :src="item.imgurl"></i>
                                <span class="tit">{{ item.label }}</span>
                                <div class="pull-right"><i class="cg-ponit"></i></div>
                            </li>
                        </ul>
                    </div>
                    <div class="show-money">
                        <ul>
                            <li>订单金额 ￥{{ toBePaid }}</li>
                        </ul>
                        <div style="clear: both;"></div>
                        <div class="linecon">
                            <p class="money-sf">
                                <span class="sf-tit">应付金额：</span><span class="shifu">￥<i class="PayRealMoney">{{
                                    toBePaid
                                }}</i></span>
                            </p>
                            <a class="btn-submit-pay" @click="goPay">提交支付</a>
                        </div>
                    </div>
                </el-row>
                <div class="returnbox" @click="returnback">
                    <a>>返回上一步</a>
                </div>
            </div>
        </el-row>
        <!-- 支付弹框 -->
        <el-dialog width="500px" :visible.sync="pay_dialog.inner_dialog.visible" append-to-body class="payInnerDialog"
            @close="close">

            <div slot="title" class="dialog-title" style="display: flex;align-items: center">
                <img :src="pay_dialog.payType === 'wechat' ? require('../../assets/wechat.png') : require('../../assets/alipay.png')"
                    alt="">
                <span style="margin-left: 1em">{{ pay_dialog.inner_dialog.title }}</span>
            </div>
            <!-- 微信支付 -->
            <div v-if="pay_dialog.payType === 'wechat'" id="qrcode" ref="qrcode"
                style="border: none;margin-left: 50%;transform: translateX(-50%)"></div>
            <iframe v-else :src="pay_dialog.inner_dialog.imgSrc" width="200px" height="210px"
                style="border: none;margin-left: 50%;transform: translateX(-50%)"></iframe>
            <p class="tip" style="color:red;text-align: center">请扫码支付 ￥{{ toBePaid }}</p>
        </el-dialog>
    </div>
</template>
<script>
import {
    creatOrder,
    getWeChatPayQRCodec,
    getAliPayQRCodec,
    getThesisPlagiarismPrice,
    getPayDetailByOrderId,
    thesisPlagiarismCheckList
} from "../../common/services";
import QRCode from 'qrcodejs2'
export default {
    name: "check",
    data() {
        return {
            ruleForm: {
                title: '',
                author: '',
                fileName: ''
            },
            rules: {
                title: [
                    { required: true, message: '论文标题', trigger: 'blur' },
                ],
                author: [
                    { required: true, message: '论文作者', trigger: 'blur' },
                ],
                fileName: [
                    { required: true, message: '论文附件', trigger: 'blur' },
                ]
            },
            file: '',
            flag1: true,
            flag2: false,
            recordData: [],
            orderData: [],//订单表格
            changepay: [
                {
                    label: '微信支付',
                    value: 'wechat',
                    imgurl: require('../../images/icon-wx.png')
                },
                {
                    label: '支付宝支付',
                    value: 'alipay',
                    imgurl: require('../../images/icon-zfb.png')
                }
            ],
            activeval: 'wechat',
            toBePaid: 0,//待支付金额
            payId: '',//支付订单号
            pay_dialog: {
                visible: false,
                title: "选择支付方式",
                payType: "wechat",
                inner_dialog: {
                    imgSrc: "",
                    visible: false,
                    title: "微信支付",
                }
            },
            timer: null,
            timer2: null,
            uploadLoading: false,
            thesisPlagiarismCheckListData: [], //检测报告列表
            isDisabled: false

        };
    },
    created() {
        this.thesisPlagiarismCheckList();
                    this.thesisPlagiarismCheckListTimer()//定时
    },
    methods: {
        onFileChange(e) {
            this.ruleForm.fileName = e.target.files[0];

        },
        saveUpdate() {
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    //   this.flag1 = false
                    //   this.flag2 = true
                    const formData = new FormData();
                    formData.append('title', this.ruleForm.title);
                    formData.append('author', this.ruleForm.author);
                    formData.append('fileName', this.ruleForm.fileName);
                    // debugger
                    this.$store.dispatch("thesis/commitWeiPuPlagiarismCheck", formData).then((ret) => {
                        if (ret.code == 0) {
                            this.$message({
                                showClose: true,
                                message: '提交成功',
                                type: 'success'

                            });
                            window.open(ret.data)
                            this.thesisPlagiarismCheckList();
                    this.thesisPlagiarismCheckListTimer()//定时
                        } else {
                            this.$message.error(ret.msg);
                        }
                    }).catch((err) => {
                    });
                    //   this.creatOrder()
                    //   this.getThesisPlagiarismPrice()
                }
            })
        },
        resetForm() {
            this.ruleForm = {
                title: '',
                author: '',
                fileName: ''
            }
            this.$refs['ruleForm'].resetFields();

        },
        returnback() {
            this.flag1 = true
            this.flag2 = false
        },
        async step2() { //后期删
            await this.creatOrder()
            await this.getThesisPlagiarismPrice()
        },
        //创建订单
        async creatOrder() {
            const res = await creatOrder();
            if (res.code == 0 || res.code == '0') {
                this.payId = res.data;
                this.orderData.push({
                    'outTradeNo': res.data,
                    'title': this.ruleForm.title,
                    'author': this.ruleForm.author,
                })
            }
        },
        /* 获取金额 */
        async getThesisPlagiarismPrice() {
            let res = await getThesisPlagiarismPrice()
            this.toBePaid = res.data
        },
        tab(value) {
            this.activeval = value;
        },
        /* 支付 */
        async goPay() {
            //开启定时器
            this.startTimerGetPayDetailByOrderId();
            const originDialog = this.pay_dialog;
            const originInnerDialog = originDialog.inner_dialog;
            const payType = originDialog.payType = this.activeval;
            this.pay_dialog.inner_dialog = {
                ...originInnerDialog,
                visible: true,
                title: payType === 'wechat' ? '微信支付' : '支付宝支付'
            }

            const imgPath = await this.getPayQRCode(payType);
            console.log('获取到的图片地址', imgPath);
            this.pay_dialog.inner_dialog.imgSrc = imgPath;
        },
        async getPayQRCode(type = 'wechat') {
            //支付宝直接获取地址展示，微信获取到之后要将文本转成二维码
            const fn = type === 'wechat' ? getWeChatPayQRCodec : getAliPayQRCodec;
            const res = await fn(this.payId);
            //区分微信、支付宝
            if (type == 'wechat') {
                const imgPath = this.getWeChatQrcode(res.data);
                console.log(imgPath)
                return "";
            } else {
                return res.data;
            }
        },
        getWeChatQrcode(text) {
            this.$refs.qrcode.innerHTML = "";
            return new QRCode('qrcode', {
                width: 200, // 设置宽度，单位像素
                height: 200, // 设置高度，单位像素
                text,   // 设置二维码内容或跳转地址
            })
        },
        close() {
            this.stopTimer()
        },
        //轮询查看支付状态 支付成功停掉定时轮询
        startTimerGetPayDetailByOrderId() {
            this.timer = setInterval(() => {
                let outTradeNo = this.payId;
                getPayDetailByOrderId(outTradeNo).then((res) => {

                    if (res.code == 0 || res.code == '0') {
                        if (res.data.payStatus == 1 || res.data.payStatus == '1') {
                            this.$message({
                                showClose: true,
                                message: '支付成功',
                                type: 'success'
                            });
                            this.pay_dialog.inner_dialog = false
                            this.flag1 = true
                            this.flag2 = false
                            //文件上传流程
                            this.paperupload();
                            //清除定时器
                            this.stopTimer();
                        }
                    }
                })

            }, 5000); // 每1秒更新一次时间
        },
        stopTimer() {
            if (this.timer !== null) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        /* 文件上传流程 */
        paperupload() {
            this.uploadLoading = true
            const formData = new FormData();
            formData.append('title', this.ruleForm.title);
            formData.append('author', this.ruleForm.author);
            formData.append('fileName', this.ruleForm.fileName);
            this.$store.dispatch("thesis/commitWanXinPlagiarismCheck", formData).then((ret) => {
                if (ret.code == 0) {
                    this.$message({
                        showClose: true,
                        message: '文件上传成功',
                        type: 'success'
                    });
                    this.uploadLoading = false
                    this.isDisabled = true
                    //开启轮询

                } else {
                    this.$message.error(ret.msg);
                }
            }).catch((err) => {
            });
            //移至code==0


        },
        /* 论文查询 */
        thesisPlagiarismCheckList() {
            const formData = new FormData();
            this.$store.dispatch("thesis/thesisPlagiarismCheckList", formData).then((ret) => {
                if (ret.code == 0) {
                    this.recordData = ret.data
                    this.thesisPlagiarismCheckListData = ret.data
                } else {
                    this.$message.error(ret.msg);
                }
            }).catch((err) => {
            });

        },
        thesisPlagiarismCheckListTimer() {
            this.timer2 = setInterval(() => {
                const formData = new FormData();
                this.$store.dispatch("thesis/thesisPlagiarismCheckList", formData).then((ret) => {
                    if (ret.code == 0) {
                        this.thesisPlagiarismCheckListData = ret.data
                        //is_checked =1 && check_status=0 创建成功  is_checked =1 && check_status=1   is_checked =0 正在检测   停止轮询
                        let checkCreate = is_checkedOne = ret.data.some((item) => {
                            if (item.check_status == 0 && item.is_checked == 1) {
                                return true
                            }
                        })
                        let checkDetection = is_checkedOne = ret.data.some((item) => {
                            if (item.check_status == 1 && item.is_checked == 1) {
                                return true
                            }
                        })
                        let unaudited = ret.data.some((item) => {
                            if (item.is_checked == 0) {
                                return true
                            }
                        })
                        if (checkCreate || checkDetection || unaudited) {

                        } else {

                            this.stopTimer2()
                        }

                    } else {
                        this.$message.error(ret.msg);
                    }
                }).catch((err) => {
                });
            }, 40000)
        },
        stopTimer2() {
            if (this.timer2 !== null) {
                clearInterval(this.timer2);
                this.timer2 = null;
            }
        },
        //下载
        downloadFile(url) {
            if(url == null ){
                alert("无下载的报告");
                return;
            }
            //下载文件
            var a = document.createElement("a");
            a.setAttribute("href", url);
            let clickEvent = document.createEvent("MouseEvents");
            clickEvent.initEvent("click", true, true);
            a.dispatchEvent(clickEvent);
        },

    }
};
</script>
<style lang="less">
@import '../../styles/base.less';

.el-Require {
    .wd {
        color: @red;
    }

}

div,
span {
    box-sizing: border-box;
}

.topbanner1 {
    height: 200px;
    // background: url(../../images/vpcs.png) no-repeat 0 0;
    width: 50%;
    margin: 0 auto;
    img{
        width: 100%;
        height: 100%;
    }
}

.demo-ruleForm {
    width: 960px;
    margin: 0 auto;
    margin-top: 50px;
}

.checkcontent {
    padding-top: 20px;

}

.orderpaysyle {
    margin-top: 50px;
}

.choose-way {
    width: 50%;
    padding: 30px 50px 23px;
    background-color: white;
    border-right: 1px #e7e7e7 solid;
}

.moneypart {
    border: 1px #efefef solid;
    height: 205px;
    display: flex;
}

.choose-way {
    ul {
        list-style: none;

        li {
            height: 58px;
            display: flex;
            align-items: center;
            position: relative;

            .tit {
                margin-left: 10px;
                font-size: 15px;
            }

            .pull-right {
                float: right !important;
                position: absolute;
                right: 0px;

                .cg-ponit {
                    margin-top: 8px;
                    width: 20px;
                    height: 20px;
                    display: inline-block;
                    vertical-align: middle;
                    background: url('../../images/icon-graypoint.png') no-repeat 0 0
                }
            }
        }

        .active {
            .pull-right {
                .cg-ponit {
                    background: url('../../images/icon-redpoint.png') no-repeat 0 0
                }
            }
        }

    }
}

.show-money {
    width: 50%;
    padding: 25px 20px 17px 20px;
    background: url(../../images/bg-show-money.png) no-repeat center center;
    background-size: 100% 100%;

    ul {
        float: right;
        margin-right: 30px;
    }
}

.linecon {
    border-top: 1px silver dashed;
    text-align: right;
    padding-right: 30px;
}

.btn-submit-pay {
    display: block;
    width: 150px;
    height: 50px;
    background: none;
    background-color: #008fd5;
    line-height: 50px;
    font-weight: normal;
    font-size: 18px;
    position: relative;
    text-align: center;
    color: #fff;
    border-radius: 2px;
    float: right;
    cursor: pointer;
    margin-top: 10px;

    &::after {
        content: "";
        width: 100%;
        height: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: all 0.5s;
    }
}

.linka {
    color: #409EFF;
    cursor: pointer;
}

.returnbox {
    margin-top: 20px;
    margin-bottom: 20px;
    color: #008fd5;

    a {
        font-size: 18px;
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/transactionPaper/duplicateCheck.vue